import React, { useState, useRef } from "react";
import { TopButs } from "./TopButs"
import { FormBox } from "./FormBox"
import { MaterialTableBox } from "./materialTableBox"
import { ItemTableBox } from "./itemTableBox"
import { FixedBottom } from "./FixedBottom"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types"

export const BmsMaintenanceDetails = () => {
    const { getSelectedNavState } = useNavModel();

    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const IFormRef = useRef<IYhFormRef>();
    return (
        <>
            <TopButs {...detailsInfo} />
            <FormBox  {...detailsInfo} />
            <ItemTableBox {...detailsInfo} />
            <MaterialTableBox {...detailsInfo} IFormRef={IFormRef} />
            <FixedBottom {...detailsInfo} />
        </>
    )
}